// extracted by mini-css-extract-plugin
export default {"deleteButton":"rcfrR","select_field":"SOfJo","select_field_label":"Hjl_w"};